import React from 'react';
import ModalContainer from 'components/shared/modal/modal_container';
import RenderInBody from 'components/shared/render_in_body';
import request from 'utils/request_ajax';
import { routes } from 'constants/config';
import { Button, ButtonGroup, Icon } from 'ui';
import { Text, TEXT_VARIANTS } from 'components/ui/Typography';
import { withSkillsClientWrapper } from 'components/shared/Skills/SkillsClientProvider';
import { withReactQueryWrapper } from 'components/shared/ReactQuery/ReactQueryProvider';

const DeleteContentModal = ({
  closeModal,
  contentId,
  setTags,
  tags,
  tagName,
}) => {
  const deleteTag = tag => {
    request.delete(routes.TAGS_DELETE(contentId)).then(() => {
      setTags(tags.filter(({ id }) => id !== contentId));
      closeModal();
    });
  };

  return (
    <RenderInBody>
      <ModalContainer
        className="ModalTakeover-background Modal-background d-f ai-c"
        onEscape={closeModal}
      >
        <div className="ModalTakeover-container w-55p">
          <div className="TemplateCreationModal-body">
            <div className="TemplateCreationModal-title">
              {t('tags.delete_tag')}
            </div>
            <div className="mt-16">
              <Text variant={TEXT_VARIANTS.BODY}>
                {t('tags.new_confirm_destroy', { tag_name: tagName })}
              </Text>
            </div>
            <div className="mt-24">
              <ButtonGroup alignEnd>
                <Button type="cancel" onClick={closeModal}>
                  {t('common.cancel')}
                </Button>
                <Button
                  className="Button--danger"
                  onClick={() => deleteTag(contentId)}
                >
                  {t('tags.delete_tag')}
                </Button>
              </ButtonGroup>
            </div>
            <button
              type="button"
              aria-label={t('common.close')}
              className="u-resetBtn ModalTakeover-closeButton"
              onClick={closeModal}
            >
              <Icon name="error" />
            </button>
          </div>
        </div>
      </ModalContainer>
    </RenderInBody>
  );
};

export default withSkillsClientWrapper(
  withReactQueryWrapper(DeleteContentModal),
);
